module.exports = __webpack_public_path__ + "static/hq-4030004e2ded39748dceba80f463cc64.jpg";